import(/* webpackMode: "eager", webpackExports: ["LoveFortunePageContent"] */ "/vercel/path0/app/love-fortune-cookie-messages/LoveFortunePageContent.tsx");
